import PropTypes from 'prop-types';

import CustomSVGIcon from './CustomSVGIcon';

const WalkingTransitionIconSet = ({ fromColor = '', toColor = '', ...other }) => {
	return (
		<CustomSVGIcon {...other}>
			<g
				id="walkingManFirst"
				transform="translate(-1142.000000, -362.000000)"
				fill={fromColor}
				fillRule="nonzero"
			>
				<path d="M1146.93766,364.477064 C1147.55013,364.477064 1148.0401,363.926606 1148.0401,363.238532 C1148.0401,362.550459 1147.55013,362 1146.93766,362 C1146.32519,362 1145.83522,362.550459 1145.83522,363.238532 C1145.83522,363.926606 1146.32519,364.477064 1146.93766,364.477064 Z M1146.99891,368.743119 L1150,368.743119 L1150,367.504587 L1147.79511,367.504587 L1146.57018,365.233945 C1146.38644,364.889908 1146.01896,364.614679 1145.65148,364.614679 C1145.52898,364.614679 1145.46774,364.614679 1145.34524,364.683486 L1142.03791,365.853211 L1142.03791,369.431193 L1143.14036,369.431193 L1143.14036,366.885321 L1144.42654,366.40367 L1142.03791,377 L1143.14036,377 L1144.91651,371.426579 L1146.32519,373.559633 L1146.32519,377 L1147.42763,377 L1147.42763,372.596303 L1145.89646,369.499973 L1146.32519,367.504587 L1146.99891,368.743119 Z" />
			</g>

			<g id="rightArrow" transform="translate(-1139.000000, -369.000000)" fill={toColor} fillRule="nonzero">
				<polygon
					id="rightArrowSmall"
					transform="translate(1148.379147, 377.958333) scale(-1, 1) rotate(-180.000000) translate(-1140.379147, -370.958333) "
					points="1141.04295 370.593791 1140.37915 369.5 1141.04295 369.5 1142.03791 370.958131 1141.04295 372.416667 1140.37915 372.416667 1141.04295 371.322472 1138.72038 371.322472 1138.72038 370.593791"
				/>
			</g>

			<g id="walkingManSecond" transform="translate(-1131.000000, -362.000000)" fill={toColor} fillRule="nonzero">
				<path d="M1146.93766,364.477064 C1147.55013,364.477064 1148.0401,363.926606 1148.0401,363.238532 C1148.0401,362.550459 1147.55013,362 1146.93766,362 C1146.32519,362 1145.83522,362.550459 1145.83522,363.238532 C1145.83522,363.926606 1146.32519,364.477064 1146.93766,364.477064 Z M1146.99891,368.743119 L1150,368.743119 L1150,367.504587 L1147.79511,367.504587 L1146.57018,365.233945 C1146.38644,364.889908 1146.01896,364.614679 1145.65148,364.614679 C1145.52898,364.614679 1145.46774,364.614679 1145.34524,364.683486 L1142.03791,365.853211 L1142.03791,369.431193 L1143.14036,369.431193 L1143.14036,366.885321 L1144.42654,366.40367 L1142.03791,377 L1143.14036,377 L1144.91651,371.426579 L1146.32519,373.559633 L1146.32519,377 L1147.42763,377 L1147.42763,372.596303 L1145.89646,369.499973 L1146.32519,367.504587 L1146.99891,368.743119 Z" />
			</g>
		</CustomSVGIcon>
	);
};

WalkingTransitionIconSet.propTypes = {
	fromColor: PropTypes.string,
	toColor: PropTypes.string,
};

export default WalkingTransitionIconSet;
